<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CW9ntR/tc-custom/9781137000583.jpg?1737763018642" alt="This image is the cover for the book The Divorce of Henry VIII"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Divorce of Henry VIII
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1533 the English monarch Henry VIII decided to divorce his wife of twenty years Catherine of Aragon in pursuit of a male heir to ensure the Tudor line. He was also head over heels in love with his wife's lady in waiting Anne Boleyn, the future mother of Elizabeth I. But getting his freedom involved a terrific web of intrigue through the enshrined halls of the Vatican that resulted in a religious schism and the formation of the Church of England. Henry's man in Rome was a wily Italian diplomat named Gregorio Casali who drew no limits on skullduggery including kidnapping, bribery and theft to make his king a free man. In this absorbing narrative, winner of the Rome Fellowship prize and University of Durham historian Catherine Fletcher draws on hundreds of previously-unknown Italian archive documents to tell the colorful tale from the inside story inside the Vatican.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catherine Fletcher
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fae1200